import {types} from './types';

export function saveProfileImage(data) {
  return {
    type: types.PROFILE_IMAGE,
    payload: data,
  };
}
